import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { CONSTANTS as MESSAGE_CENTER_CONSTANTS } from '@/js/helper/message-center-constants.js'
import QUICK_BUY_CONSTANTS from '@/js/helper/quick-buy-constants.js'
import COMPARE_CONSTANTS from '@/js/helper/compare-constants.js'

export const ROUTES = {
  SKU_DETAIL: {
    name: 'sku-detail',
    path: '/products/sku/:sku',
  },
  SKU_DETAIL_WAIT: {
    name: 'sku-detail-wait',
    path: '/products/sku/w/:sku',
  },
  PRODUCTS: {
    name: 'products',
    path: '/products',
  },
  FILTER: {
    name: 'filter',
    path: '/products/filter/:filterId',
  },
  DEFAULT: {
    name: 'default',
    path: '/',
  },
  [FILTER_CONSTANTS.SCOPE.DEBUG]: {
    name: FILTER_CONSTANTS.SCOPE.DEBUG,
    path: '/allproducts',
  },
  [FILTER_CONSTANTS.SCOPE.BIKES]: {
    name: FILTER_CONSTANTS.SCOPE.BIKES,
    path: '/products/bikes',
  },
  [FILTER_CONSTANTS.SCOPE.BIKES_ITEMS]: {
    name: FILTER_CONSTANTS.SCOPE.BIKES_ITEMS,
    path: '/products/bikesitems',
  },
  [FILTER_CONSTANTS.SCOPE.ACCESSORIES]: {
    name: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
    path: '/products/accessories',
  },
  [FILTER_CONSTANTS.SCOPE.SERVICE]: {
    name: FILTER_CONSTANTS.SCOPE.SERVICE,
    path: '/products/spareparts',
  },
  [FILTER_CONSTANTS.SCOPE.PART_SALE]: {
    name: FILTER_CONSTANTS.SCOPE.PART_SALE,
    path: '/products/parts-sale',
  },
  [FILTER_CONSTANTS.SCOPE.CURRENT]: {
    name: FILTER_CONSTANTS.SCOPE.CURRENT,
    path: '/products/bikes/current',
  },
  [FILTER_CONSTANTS.SCOPE.OUTLET]: {
    name: FILTER_CONSTANTS.SCOPE.OUTLET,
    path: '/products/bikes/outlet',
  },
  [FILTER_CONSTANTS.SCOPE.ARCHIVE]: {
    name: FILTER_CONSTANTS.SCOPE.ARCHIVE,
    path: '/archive',
  },
  ALL_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.ALL}-detail`,
    path: '/products/detail/:productId',
  },
  BIKE_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.BIKES}-detail`,
    path: '/products/bikes/detail/:productId',
  },
  BIKE_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.BIKES}-detail-sku`,
    path: '/products/bikes/detail/:productId/sku/:highlightSku',
  },

  SPAREPART_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.SERVICE}-detail`,
    path: '/products/spareparts/detail/:productId',
  },
  SPAREPART_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.SERVICE}-detail-sku`,
    path: '/products/spareparts/detail/:productId/sku/:highlightSku',
  },
  ACCESSORY_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.ACCESSORIES}-detail`,
    path: '/products/accessories/detail/:productId',
  },
  ACCESSORY_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.ACCESSORIES}-detail-sku`,
    path: '/products/accessories/detail/:productId/sku/:highlightSku',
  },
  CURRENT_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.CURRENT}-detail`,
    path: '/products/bikes/current/detail/:productId',
  },
  CURRENT_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.CURRENT}-detail-sku`,
    path: '/products/bikes/current/detail/:productId/sku/:highlightSku',
  },
  OUTLET_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.OUTLET}-detail`,
    path: '/products/bikes/outlet/detail/:productId',
  },
  OUTLET_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.OUTLET}-detail-sku`,
    path: '/products/bikes/outlet/detail/:productId/sku/:highlightSku',
  },
  ARCHIVE_DETAIL_OLD: {
    name: `${FILTER_CONSTANTS.SCOPE.ARCHIVE}-detail-old`,
    path: '/products/archive/detail/:productId',
  },
  ARCHIVE_DETAIL_SKU_OLD: {
    name: `${FILTER_CONSTANTS.SCOPE.ARCHIVE}-detail-sku-old`,
    path: '/products/archive/detail/:productId/sku/:highlightSku',
  },
  ARCHIVE_DETAIL: {
    name: `${FILTER_CONSTANTS.SCOPE.ARCHIVE}-detail`,
    path: '/archive/detail/:productId',
  },
  ARCHIVE_DETAIL_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.ARCHIVE}-detail-sku`,
    path: '/archive/detail/:productId/sku/:highlightSku',
  },
  SEARCH_SN: {
    name: 'serial-number-search',
    path: '/serialnumbersearch/:serialNumber?',
  },
  SPAREPARTS_SN: {
    name: `${FILTER_CONSTANTS.SCOPE.SERVICE}-sn`,
    path: '/products/spareparts/sn/:serialNumber',
  },
  SPAREPARTS_SKU: {
    name: `${FILTER_CONSTANTS.SCOPE.SERVICE}-sku`,
    path: '/products/spareparts/sku/:sku',
  },
  MESSAGE_CENTER_LIST: {
    name: MESSAGE_CENTER_CONSTANTS.ROUTES.LIST,
    path: '/messages',
  },
  QUICK_BUY: {
    name: QUICK_BUY_CONSTANTS.ROUTES.QUICK_BUY.NAME,
    path: QUICK_BUY_CONSTANTS.ROUTES.QUICK_BUY.PATH,
  },
  COMPARE: {
    name: COMPARE_CONSTANTS.ROUTES.COMPARE.NAME,
    path: COMPARE_CONSTANTS.ROUTES.COMPARE.PATH,
  },
  PRODUCT_ATTRIBUTES: {
    name: 'productattributes',
    path: '/productattributes',
  },
  CHECKOUT: {
    name: 'checkout',
    path: '/checkout',
  },
  FAVORITES: {
    name: 'favorites',
    path: '/favorites',
  },
  FAVORITES_PRINT: {
    path: '/p/favorites',
    name: 'print-favorites',
  },
  USERMANAGEMENT: {
    path: '/usermanagement',
    name: 'usermanagement',
  },
  USERMANAGEMENTLIST: {
    path: '/usermanagementlist',
    name: 'usermanagementlist',
  },
  DEALER_BY_SALES_ORG: {
    path: '/dealers',
    name: 'dealers',
  },
  SET_SALES_GROUP: {
    path: '/participate_in_sales',
    name: 'participate_in_sales',
  },
  EVENT_REGISTRATION: {
    path: '/event-registration/:eventKey?',
    name: 'event-registration',
  },
}

export const ROUTE_NAMES = Object.entries(ROUTES).reduce(
  (names, [key, entry]) => ({
    ...names,
    [key]: entry.name,
  }),
  {},
)
